import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Flex, ExpandMoreIcon, Anchor } from '../../lib/components'
import { RightArrow } from '../../lib/components/Icon'

interface faqAccordionProps {
  question: string
  answer?: string
  content?: React.ReactNode
  isActive: boolean
  setIsActive: (val: boolean) => void
}

const benefits = [
  {
    title: 'Why do I invest through Credibila',
    content: (
      <>
        Credibila is a Digital Platform regulated by Financial Services Commission, Mauritius. Our
        goal is to help clients access alternative investment opportunities in private markets,
        venture debt & real estate. Signing up on Credibila allows you to look beyond traditional
        investing asset classes & evaluate alternate investment opportunities.{' '}
        <Anchor variant='basic-anchor' href='/signup' text='Know More' />
      </>
    ),
  },
  {
    title: 'Who is eligible to invest through Credibila?',
    content:
      'An individual over 18 or an institution is eligible to invest subject to the KYC being verified.',
  },
  {
    title: 'How do I begin Investing through Credibila?',
    content:
      'Begin by signing up & getting your KYC verified. Evaluate the opportunities & cherry pick basis your financial goals.',
  },
  {
    title: 'Is there a minimum commitment to invest?',
    content: 'The Investment threshold is a minimum of US $ 1000.',
  },
  {
    title: 'Are there any fees?',
    content:
      'Signing up on the Credibila platform is free. Fees linked to the investment opportunity are specified in the respective term sheet.',
  },
  {
    title: 'Is my confidential information safe with Credibila?',
    content:
      'Maintaining the integrity and security of our clients data is a priority for Credibila. We follow industry standards and address security in three major components: physical security, corporate IT security and production security. Learn More by reviewing our Privacy Policy.',
  },
  {
    title: 'Have More Questions',
  },
]

const isMoreQuestionLink = (title: string) => title === 'Have More Questions'

const Accordion = ({ question, answer, content, isActive, setIsActive }: faqAccordionProps) => {
  const navigate = useNavigate()
  return (
    <div className='accordion'>
      <div className='accordion-item'>
        <div
          className='learn-more-accordion-title'
          onClick={() => (isMoreQuestionLink(question) ? navigate('/faq') : setIsActive(!isActive))}
        >
          <div className={`${isMoreQuestionLink(question) ? 'homepage-link' : ''}`}>{question}</div>
          {isMoreQuestionLink(question) ? (
            <RightArrow />
          ) : (
            <div className='learn-more-accordion-icon'>
              {isActive ? <ExpandMoreIcon classes={['learn-more-collapse']} /> : <ExpandMoreIcon />}
            </div>
          )}
        </div>
        {isActive && <div className='accordion-content'>{content ?? answer}</div>}
      </div>
    </div>
  )
}

const LearnMoreSection = () => {
  const [isActive, setIsActive] = useState(false)
  const [activeIndex, setIsActiveIndex] = useState<number | null>(null)

  return (
    <div className='faq-accordion'>
      {benefits &&
        benefits.map(
          (
            {
              title,
              subTitle,
              content,
            }: { title: string; subTitle?: string; content?: React.ReactNode },
            index,
          ) => (
            <Accordion
              key={index}
              question={title}
              answer={subTitle}
              content={content}
              isActive={activeIndex === index ? isActive : false}
              setIsActive={(val: boolean) => {
                setIsActiveIndex(index)
                return setIsActive(val)
              }}
            />
          ),
        )}
    </div>
  )
}

export { LearnMoreSection }
